var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-steps"},[_c('StepsHeader',{attrs:{"showStep":_vm.step}}),_c('div',{staticClass:"steps-content"},[_c(_vm.componentsMap[_vm.step],{tag:"component",on:{"back":_vm.back,"forward":_vm.forward}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }